export type BannerType = 0 | 1

export type SiteBanner = {
  id: string
  type: BannerType
  status?: number
  linkType: 0 | 1
  priority?: number
  image: string
  mobileImage?: string | null
  link: string
}

export const BANNER_AUTOPLAY_DELAY = 3000

export function prepareBanners(banners: SiteBanner[], type: BannerType) {
  const seen = new Set<string>()
  return banners
    .filter((banner) => {
      if (
        banner.type !== type ||
        (banner.status ?? 0) !== 0 ||
        !/^https?:\/\//i.test(banner.image.trim()) ||
        seen.has(banner.id)
      ) {
        return false
      }
      seen.add(banner.id)
      return true
    })
    .sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0))
}

export function getBannerLayers(banners: SiteBanner[], activeIndex: number) {
  return Array.from({ length: Math.min(3, banners.length) }, (_, depth) => {
    const index = (activeIndex + depth) % banners.length
    return { banner: banners[index]!, index, depth }
  }).reverse()
}

export function getBannerLink(banner: Pick<SiteBanner, "link" | "linkType">) {
  const link = banner.link.trim()
  if (
    !link ||
    link.includes("\\") ||
    Array.from(link).some((character) => {
      const code = character.charCodeAt(0)
      return code < 32 || code === 127
    }) ||
    (/^[a-z][a-z\d+.-]*:/i.test(link) && !/^https?:\/\//i.test(link))
  ) {
    return null
  }

  if (banner.linkType === 0 && !/^https?:\/\//i.test(link)) {
    if (link.startsWith("//")) return null
    return {
      href: /^[/?#]/.test(link) ? link : `/${link}`,
      external: false,
    }
  }

  try {
    const url = new URL(
      /^https?:\/\//i.test(link) ? link : `https://${link.replace(/^\/\//, "")}`
    )
    if (!url.hostname || url.username || url.password) return null
    return { href: url.href, external: banner.linkType === 1 }
  } catch {
    return null
  }
}
